document.addEventListener("DOMContentLoaded", function () {
  handleExpandableImagery();
});

function handleExpandableImagery() {
  const expandableElements = document.querySelectorAll(
    ".am-eph__hero, .am-podcast__hero-wrapper"
  );

  if (expandableElements.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("expanding");
          // Stop observing to prevent memory leaks
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
    }
  );

  // Observe each element
  expandableElements.forEach((element) => {
    observer.observe(element);
  });
}
